module.exports = __webpack_public_path__ + "static/img/2025-07-03.9f92785e.png";